import * as stylex from '@stylexjs/stylex';
import { styles } from '../styles';

const Lock = () => {
  return (
    <svg
      {...stylex.props(styles.lockIcon)}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Icon / Lock">
        <path
          id="Vector"
          d="M5.03028 7.06668V4.92746C5.03028 3.29486 6.38786 2 7.9717 2C9.6121 2 10.9131 3.35116 10.9131 4.92746V7.06668M7.97173 10.0505V11.7394M3.33334 7.9111C3.33334 7.46072 3.7293 7.06665 4.18183 7.06665H11.8182C12.2707 7.06665 12.6667 7.46072 12.6667 7.9111V13.8222C12.6667 14.2726 12.2707 14.6667 11.8182 14.6667H4.18183C3.7293 14.6667 3.33334 14.2726 3.33334 13.8222V7.9111Z"
          stroke="#1D252D"
          strokeOpacity="0.3"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export default Lock;
